import { Box, BoxProps } from '@chakra-ui/react'
import { useOnboardingHighlight } from '@src/components/sco/Requests/RequestOnboarding/OnboardingHighlightContext'
import React, { useEffect, useRef } from 'react'

export const ONBOARDING_HIGHLIGHT_IDS = {
  requestListCard: 'onboarding-request-list-card',
  gamePlanListCard: 'onboarding-game-plan-list-card',
  aiChat: 'onboarding-ai-chat',
  getMatched: 'onboarding-get-matched',
  /** Add more IDs here and use them in ExplainerBlockItemContentArray and OnboardingHighlightTarget. */
} as const

type OnboardingHighlightTargetProps = BoxProps & {
  id: string
  children: React.ReactNode
  /** If true, scroll element into view when it becomes highlighted. Default true. */
  scrollIntoView?: boolean
}

export const OnboardingHighlightTarget: React.FC<OnboardingHighlightTargetProps> = ({
  id,
  children,
  scrollIntoView = true,
  ...boxProps
}) => {
  const { highlightTargetId } = useOnboardingHighlight()
  const ref = useRef<HTMLDivElement>(null)
  const isHighlighted = highlightTargetId === id

  useEffect(() => {
    if (!isHighlighted || !scrollIntoView || !ref.current) {
      return
    }
    ref.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
  }, [isHighlighted, scrollIntoView])

  return (
    <Box
      ref={ref}
      borderRadius={'md'}
      boxShadow={isHighlighted ? '0 0 0 4px var(--chakra-colors-actionActiveAlpha-400)' : undefined}
      outlineColor={isHighlighted ? 'actionActive' : undefined}
      outlineOffset={isHighlighted ? 2 : undefined}
      position={'relative'}
      sx={
        isHighlighted
          ? {
              animation: 'onboarding-pulse 2s ease-in-out infinite',
              '@keyframes onboarding-pulse': {
                '0%, 100%': {
                  boxShadow: '0 0 0 4px var(--chakra-colors-actionActiveAlpha-400)',
                },
                '50%': {
                  boxShadow: '0 0 0 8px var(--chakra-colors-actionActiveAlpha-300)',
                },
              },
            }
          : undefined
      }
      transition={'box-shadow 0.2s ease, outline 0.2s ease'}
      // bgColor={isHighlighted ? 'Slate_20' : undefined}
      outline={isHighlighted ? '2px solid' : undefined}
      {...boxProps}
    >
      {children}
    </Box>
  )
}
